import { Injectable } from "@angular/core";
import { ICloudsOverviewStateService } from "./i-clouds-overview-state-service";
import { ICloud } from "../../models/i-cloud";
import { AOverviewStateService } from "@zaeper/angular-dashboard-view-lib";

@Injectable()
export class CloudsOverviewStateService extends AOverviewStateService<ICloud> implements ICloudsOverviewStateService {

}
